import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Lato\",\"arguments\":[{\"weight\":[\"400\",\"700\"],\"style\":[\"normal\"],\"subsets\":[\"latin\"],\"variable\":\"--font-lato\"}],\"variableName\":\"lato\"}");
;
import(/* webpackMode: "eager" */ "/app/packages/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/packages/frontend/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TargomoKeyProvider"] */ "/app/packages/frontend/src/features/isochrone/TargomoKeyContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectProvider"] */ "/app/packages/frontend/src/features/project/ProjectContext.tsx");
